// extracted by mini-css-extract-plugin
module.exports = {"magic_bg":"photo-to-sketch_magic_bg__ncf_I"};